import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MessageSquare } from "lucide-react";

export default function FloatingCTA() {
  const { t } = useTranslation();

  return (
    <div className="fixed bottom-5 left-0 right-0 flex justify-center z-40 lg:hidden px-4">
      <Link
        to="/contact"
        data-testid="floating-cta"
        className="flex items-center gap-2 px-7 py-3.5 bg-[#0B3C5D] text-white font-semibold text-sm rounded-full shadow-[0_8px_30px_rgba(11,60,93,0.4)] hover:bg-[#3FA7D6] transition-all duration-200 hover:scale-105"
      >
        <MessageSquare className="w-4 h-4" />
        {t("nav.getConsultation")}
      </Link>
    </div>
  );
}
